
import { TweenMax, Power4 } from 'gsap'

export default {
  name: 'ApzCollapse',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    open: {
      type: Boolean,
      default: true
    },
    ariaId: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'is-top',
      validator(value) {
        return ['is-top', 'is-bottom'].indexOf(value) > -1
      }
    },
    triggerClass: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    },
    isNotCollapsible: Boolean
  },
  data() {
    return {
      isOpen: this.open
    }
  },
  watch: {
    open(value) {
      this.isOpen = value
    }
  },
  methods: {
    toggle() {
      if (this.isNotCollapsible) return
      this.isOpen = !this.isOpen
      this.$emit('update:open', this.isOpen)
      this.$emit(this.isOpen ? 'open' : 'close')
    },
    beforeEnter(el) {
      el.style.overflow = 'hidden'
    },
    enter(el, done) {
      TweenMax.fromTo(
        el,
        {
          autoAlpha: 0,
          height: 0
        },
        {
          autoAlpha: 1,
          height: el.scrollHeight,
          ease: Power4.easeOut,
          onComplete: () => {
            if (this.isOpen) {
              el.style.overflow = 'visible'
              el.style.height = 'unset'
            }
            done()
          }
        }
      )
    },
    beforeLeave(el) {
      el.style.overflow = 'hidden'
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        {
          autoAlpha: 1,
          height: el.scrollHeight
        },
        {
          autoAlpha: 0,
          height: 0,
          ease: Power4.easeOut,
          onComplete: done
        }
      )
    }
  },
  render(createElement) {
    const trigger = createElement(
      'div',
      {
        ...(!!this.triggerClass && { class: this.triggerClass }),
        staticClass: 'collapse-trigger',
        attrs: {
          role: 'button'
        },
        on: { click: this.toggle }
      },
      this.$scopedSlots.trigger
        ? [this.$scopedSlots.trigger({ open: this.isOpen })]
        : [this.$slots.trigger]
    )
    const content = createElement(
      'transition',
      {
        appear: true,
        on: {
          'before-enter': this.beforeEnter,
          enter: this.enter,
          'before-leave': this.beforeLeave,
          leave: this.leave
        }
      },
      [
        createElement(
          'div',
          {
            ...(!!this.contentClass && { class: this.contentClass }),
            staticClass: 'collapse-content',
            attrs: {
              ...(!!this.ariaId && { id: this.ariaId }),
              'aria-expanded': this.isOpen
            },
            directives: [
              {
                name: 'show',
                value: this.isOpen
              }
            ]
          },
          this.$slots.default
        )
      ]
    )
    return createElement(
      this.tag,
      { staticClass: 'collapse', class: (this.isOpen && 'is-open') || '' },
      this.position === 'is-top' ? [trigger, content] : [content, trigger]
    )
  }
}
